function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEmergencyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.794 7.548L10.5 2.718l1.932-.517 1.294 4.83-1.932.517zM18.506 7.03L19.8 2.2l1.932.518-1.294 4.83-1.932-.518zM23.965 10.536L27.5 7l1.414 1.414-3.535 3.536-1.415-1.414zM3.464 8.414L7 11.95l1.414-1.414L4.88 7 3.464 8.414zM22 22.5V17a6 6 0 00-12 0v5.5h12zM16 9a8 8 0 00-8 8v7.5h16V17a8 8 0 00-8-8z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 24.5H8V28h16v-3.5zm-16-2a2 2 0 00-2 2V28a2 2 0 002 2h16a2 2 0 002-2v-3.5a2 2 0 00-2-2H8zM15.99 13.858a1 1 0 01-.848 1.132 1.953 1.953 0 00-1.652 1.652 1 1 0 11-1.98-.284 3.953 3.953 0 013.348-3.348 1 1 0 011.132.848z",
    fill: props.color
  }));
}

export default SvgIconEmergencyFilled;